$("#toggle-wishlist").click(function () {
    $("#wishlist-drawer").toggleClass("open");
    $('body').addClass('no-scroll');
    if ( $('.wishlist-drawer-content #customer_login').length > 0 ) {
        $('.wishlist-drawer-content #customer_login input[type="email"]').focus();
    }
});

$("#close-wishlist").click(function () {
    $("#wishlist-drawer").removeClass("open");
    $('body').removeClass('no-scroll');
});

// open wishlist drawer after success login
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has("wishlist_login")) {
    $("#wishlist-drawer").addClass("open");
}

$(".wd-promotional-product-wrapper .swym-button").click(function () {
    $("#wishlist-drawer").addClass("open");
});

$(".product-gallery .swym-button").click(function () {
    $("#wishlist-drawer").addClass("open");
});

//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
    fetchLists();

    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
        fetchLists();
        $("#wishlist-drawer").addClass("open");
    });

    swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
        fetchLists();
        $("#wishlist-drawer").addClass("open");
    });

    // Fetch the user lists of the shopper
    $(document).on("click", "wishlist-drawer .single-item", function () {
        document.location.href = $(this).data("href");
    });

    $(document).on("click", "wishlist-drawer .single-item .remove-wishlist", function (e) {
        e.stopPropagation();

        let parent = $(this).parents(".single-item");
        // Define the Product to be deleted
        let product = {
            epi: $(this).data("epi"), // unique variant id  per listid
            empi: $(this).data("empi"), // product id
            du: $(this).data("du"), // product url.
        };

        // Define success callback
        let onSuccess = function (deletedProduct) {
            // Executed when product is successfully deleted
            $(parent).hide("slowly");
            console.log("Successfully deleted the Product", deletedProduct);
            swat.collectionsApi.initializeCollections(swat, true, window.Shopify.theme.schema_name);
            swat.collectionsApi.removeCollectionsButtons();
        };

        // Call `deleteFromList` using the above callbacks, lid and listItem
        swat.deleteFromList($(this).data("lid"), product, onSuccess, handleError);
    });

    $(document).on("click", "wd-product-item-collection", function () {
        fetchLists();
    });

    function handleError(error) {
        console.log("SWYM error", error);
    }

    function fetchLists() {
        // Define success callback
        let onSuccess = function (lists) {
            $("#wishlist-feed .wishlist-items").empty();
            // Successfully fetched all lists
            for (let list of lists) {
                items = list.listcontents;
                // Successfully fetched list details
                if (items.length > 0) {
                    $("#wishlist-feed").show();
                    $("#empty-wishlist").hide();
                }
                for (let listItem of items) {
                    if ($("product-list").length > 0) {
                        $('product-list .swym-button[data-product-id="' + listItem.empi + '"]').addClass("filled");
                    }
                    $("#wishlist-feed .wishlist-items").append(
                        '<div data-href="' +
                            listItem.du +
                            '" class="single-item" style="background-image: url(' +
                            listItem.iu +
                            ');"><button data-lid="' +
                            listItem.lid +
                            '" data-epi="' +
                            listItem.epi +
                            '" data-empi="' +
                            listItem.empi +
                            '" data-du="' +
                            listItem.du +
                            '" type="button" class="remove-wishlist"></button><div class="item-details"><span class="item-name">' +
                            listItem.dt +
                            '</span></div></div>'
                    );
                }
            }
        };

        // Call `fetchLists` function
        swat.fetchLists({
            callbackFn: onSuccess,
            errorFn: handleError,
        });
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);
